// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"e56c31dc","166":"5c1d270d","525":"fbd384d5","779":"87b5122e","876":"7843cd3d","896":"9ffc2248"}[chunkId] + ".js";
};